import React from "react";
import { useTranslation } from "react-i18next";

export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const changeLanguage = (lng: string) => {
    i18n.changeLanguage(lng);
  };

  return (
    <div className="language-switcher">
      <button
        onClick={() => changeLanguage("it")}
        className={`btn btn-sm ${
          i18n.language === "it" ? "btn-primary" : "btn-outline-primary"
        }`}
        style={{ marginRight: "5px" }}
      >
        IT
      </button>
      <button
        onClick={() => changeLanguage("en")}
        className={`btn btn-sm ${
          i18n.language === "en" ? "btn-primary" : "btn-outline-primary"
        }`}
      >
        EN
      </button>
    </div>
  );
}
